import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'gdp-number-temporary-status',
  template: `
    <div *ngIf="temporaryStatus" class="vox-chip vox-chip_royal-blue text-uppercase">Temporary</div>
    <div *ngIf="!temporaryStatus" class="vox-chip vox-chip_aquamarine-text text-uppercase">Permanent</div>
    `
})
export class NumberTemporaryStatusComponent implements OnInit {
  @Input('temporaryStatus') temporaryStatus: boolean;
  public temporaryStatusClass: string;

  constructor() { }

  ngOnInit() {
  }

}
